import { createFileRoute } from "@tanstack/react-router";

import { CourierPrintStickers } from "@/features/courier/ui/courier-print-stcikers.tsx";
import { PageLayout } from "@/shared/components/page-layout.ui.tsx";
import { ExportDirectionProcessingOrdersModal } from "@/features/order/processing";
import { PackageQrDocument } from "@/features/courier/ui/package-qr-document.tsx";

export const Route = createFileRoute("/dashboard/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PageLayout title="Главная">
      <div className="flex flex-col pt-4 pr-4">
        <div className="grid grid-cols-4 gap-8">
          <div className="w-full h-52 rounded-2xl bg-neutral-100">
            <ExportDirectionProcessingOrdersModal />
          </div>
          <div className="w-full h-52 rounded-2xl bg-neutral-100">
            <CourierPrintStickers />
          </div>
          <div className="w-full h-52 rounded-2xl bg-neutral-100">
            <PackageQrDocument />
          </div>
          <div className="w-full h-64 rounded-2xl bg-neutral-100" />
        </div>

        <div className="grid grid-cols-2 gap-8 mt-6">
          <div className="w-full h-64 rounded-2xl bg-neutral-100" />
          <div className="w-full h-64 rounded-2xl bg-neutral-100" />
        </div>
        <div className="grid grid-cols-4  gap-8 mt-6">
          <div className="w-full h-64 rounded-2xl bg-neutral-100" />
          <div className="w-full h-64 col-span-2 rounded-2xl bg-neutral-100" />
          <div className="w-full h-64 rounded-2xl bg-neutral-100" />
        </div>
      </div>
    </PageLayout>
  );
}
